import { render, staticRenderFns } from "./tinymce-editor.vue?vue&type=template&id=072653e9&scoped=true&"
import script from "./tinymce-editor.vue?vue&type=script&lang=js&"
export * from "./tinymce-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072653e9",
  null
  
)

export default component.exports